require('waypoints/lib/noframework.waypoints');
require('waypoints/lib/shortcuts/inview');

require('picturefill');

import svg4everybody from 'svg4everybody'
import smoothScroll from 'smooth-scroll'
import utils from 'utils'
import jQuery from 'jquery'

import Masonry from 'masonry-layout';

var msnry = null;
if(document.querySelector(".projekte-wrapper") !== null){
  msnry = new Masonry( '.projekte-wrapper', {
    columnWidth: '.grid-sizer',
    itemSelector: '.projekt',
    percentPosition: true
  });
}



svg4everybody({polyfill: true});
smoothScroll.init();

var $ = jQuery;
var html = $('html');
var shadow = $('#shadow');

require.ensure([], function() {
  require('mtiFontTrackingCode');
});


var closeMenu = function(){
  html.removeClass('menu-open');
  shadow.off('click', closeMenu);
}

var openMenu = function(){
  html.addClass('menu-open');
  shadow.on('click', closeMenu);
}

$('.open-menu').on('click', openMenu);
$('.close-menu').on('click', closeMenu);

$('#menu a').on('click', closeMenu);

if(document.getElementById('slogan') !== null){
  var inview = new Waypoint.Inview({
    element: document.getElementById('slogan'),
    entered: function(d) {
      if(d === 'up')
        html.removeClass('show-slim-header')
    },
    exit: function(d) {
      if (d === 'down')
        html.addClass('show-slim-header');
    }
  })
}

if ( window.location.hash ) {
  var hash = smoothScroll.escapeCharacters( window.location.hash );
  var toggle = document.querySelector( 'a[href*="' + hash + '"]' );
  var options = {};
  $(window).load(function(){
    smoothScroll.animateScroll( hash, toggle, options );
  });
}

$(function(){
  var projectImages = $('.projekt img');
  var pIcnt = 0;
  var checkImgLoad = function(){
    pIcnt++;
    if (pIcnt >= projectImages.length){
      msnry.layout();
    }
  }

  $.each(projectImages, function(){
    if(this.complete || this.readyState === 4){
      checkImgLoad();
    }else{
      $(this).on('load', function() {
        checkImgLoad();
      });
    }
  });
});


$('a[data-show-projekte]').on('click',function(e){
  e.preventDefault();

  var p = $(this).data("show-projekte");
  var t = $(this).text();

  var wrapper = $('.projekte-wrapper');
  var projekte = wrapper.children('.projekt');
  var filter = $('[projekt-filter-container]');
  filter.find('i, a').remove();
  var a = $("<a href='#' class='remove-filter'><svg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 33.96 34.25'><path d='M30.41.05L16.97 13.48 3.54.05 0 3.58l12.73 12.73.76.77-.76.76L0 30.57l3.54 3.53 13.43-13.43L30.41 34.1l3.53-3.53-12.73-12.73-.76-.76.76-.77L33.94 3.58z'/></svg></a>");
  a.on('click', function(e){
    e.preventDefault();
    clearFilter();
  });
  filter.append("<i class='project-filter'>" + t + "</i>");
  filter.append(a);

  projekte.each(function(i,v){
    if($(this).data("projekt") == p){
      //$(this).css({"opacity": "1"});
      $(this).show();
    }else{
    //  $(this).css({"opacity": ".4"});
      $(this).hide();
    }
  });

  msnry.layout();

  smoothScroll.animateScroll(smoothScroll.escapeCharacters("projekte"), false, {} );
});

function clearFilter(){
  var wrapper = $('.projekte-wrapper');
  var projekte = wrapper.children('.projekt');
  var filter = $('[projekt-filter-container]');
  filter.find('i, a').remove();
  projekte.each(function(i,v){
      $(this).show();
  });
  msnry.layout();
}



/** WEBPACK FOOTER **
 ** ./app.js
 **/